<template>
  <div v-if="loadingStore.state.globalLoading" class="global-loading-overlay">
    <div class="loading-content">
      <div class="loading-spinner">
        <div class="spinner"></div>
      </div>
      <div class="loading-message">{{ loadingStore.state.loadingMessage }}</div>
      <div class="loading-tasks" v-if="loadingStore.state.loadingTasks.size > 0">
        <div class="task-count">
          {{ loadingStore.state.loadingTasks.size }} task{{ loadingStore.state.loadingTasks.size !== 1 ? 's' : '' }} in progress
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { loadingStore } from '../stores/loadingStore'

export default {
  name: 'GlobalLoadingOverlay',
  setup() {
    return {
      loadingStore
    }
  }
}
</script>

<style scoped>
.global-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  backdrop-filter: blur(2px);
}

.loading-content {
  background-color: white;
  padding: 40px;
  border-radius: 12px;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  max-width: 400px;
  width: 90%;
}

.loading-spinner {
  margin-bottom: 20px;
}

.spinner {
  width: 50px;
  height: 50px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #237091;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-message {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: 15px;
}

.loading-tasks {
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid #eee;
}

.task-count {
  font-size: 14px;
  color: #666;
  font-style: italic;
}
</style>
